import { GridColDef } from "@mui/x-data-grid";
import * as React from "react";
import { formatDate } from "../../helper/DateFormat";
import { ISubscriptionTableProps } from "../../interfaces/subscription-table";
import { CustomDataGrid } from "../../SharedComponents/CustomDataGrid/CustomDataGrid";

export default function SubscriptionTable(props: Readonly<ISubscriptionTableProps>) {
  const showNoData = () => {
    const rootStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "200px"
    };
    return (
      <div style={rootStyle}>{`License and Subscription details are not available for ${props.tenantName} .`} </div>
    );
  };

  const columns: GridColDef[] = [
    {
      headerName: "Subscription Id",
      field: "subscriptionId",
      width: 270,
      sortable: true
    },
    {
      headerName: "SKU Name",
      field: "sku",
      width: 240,
      sortable: true
    },
    {
      headerName: "Included Quantity",
      type: "number",
      field: "includedQuantity",
      width: 190,
      sortable: true,
      align: "left",
      headerAlign: "left"
    },

    {
      headerName: "SKU Category",
      field: "skuCategory",
      width: 170,
      sortable: true
    },
    {
      headerName: "SKU Family",
      field: "skuFamily",
      width: 130,
      sortable: true
    },
    {
      headerName: "SKU Assigned",
      field: "skuAssigned",
      width: 130,
      sortable: true
    },
    {
      headerName: "Subscription Status",
      field: "subscriptionStatus",
      width: 150,
      sortable: true
    },
    {
      headerName: "Subscription Name",
      field: "friendlySubscriptionName",
      width: 200,
      sortable: true
    },
    {
      headerName: "Subscription Created Date",
      type: "date",
      field: "subscriptionCreatedDate",
      width: 190,
      sortable: true,
      valueGetter: (value, row) => new Date(row.subscriptionCreatedDate),
      renderCell: (params) => formatDate(params.row.subscriptionCreatedDate)
    },
    {
      headerName: "Subscription Start Date",
      type: "date",
      field: "subscriptionStartDate",
      width: 190,
      sortable: true,
      valueGetter: (value, row) => new Date(row.subscriptionStartDate),
      renderCell: (params) => formatDate(params.row.subscriptionStartDate)
    },
    {
      headerName: "Subscription End Date",
      type: "date",
      field: "subscriptionEndDate",
      minWidth: 190,
      sortable: true,
      valueGetter: (value, row) => new Date(row.subscriptionEndDate),
      renderCell: (params) => formatDate(params.row.subscriptionEndDate)
    },
    {
      headerName: "Tier1 Partner MPNID",
      field: "tier1PartnerMPNID",
      minWidth: 180,
      sortable: true
    },
    {
      headerName: "Tier2 Partner MPNID",
      field: "tier2PartnerMPNID",
      minWidth: 180,
      sortable: true
    },
    {
      headerName: "Tier2 Partner MPNName",
      field: "tier1PartnerMPNName",
      minWidth: 180,
      sortable: true
    },
    {
      headerName: "Tier2 Partner MPNName",
      field: "tier2PartnerMPNName",
      minWidth: 180,
      flex: 1,
      sortable: true
    },
     {
      headerName: "Is Free",
      field: "isFree",
      minWidth: 180,
      flex: 1,
      sortable: true,
      type: "boolean"
    },
    {
      headerName: "Is Paid",
      field: "isPaid",
      minWidth: 180,
      flex: 1,
      sortable: true,
      type: "boolean"
    },
    {
      headerName: "Paid Included Quantity",
      field: "paidIncludedQuantity",
      minWidth: 180,
      flex: 1,
      sortable: true,
      type: "number"
    },
  ];

  React.useEffect(() => {
    setTimeout(() => {
      const elements = document.getElementsByClassName("MuiDataGrid-virtualScroller");
      Array.from(elements).forEach(function (element) {
        element.setAttribute("tabIndex", "0");
      });
    }, 1000);
  }, []);
  return (
    <>
      {props?.tableData && props?.tableData.length > 0 ? (
        <div tabIndex={0} style={{ height: 600 }}>
          <CustomDataGrid
            columns={columns}
            enableUrlParams
            getRowId={(row) => row.subscriptionId}
            paginationOptions={{ page: 0, pageSize: 100 }}
            rows={{ values: props.tableData ?? [], count: props.tableData?.length ?? 0 }}
            kustoLink={props.kustoLink}
            TabName={`Customer View - License and Subscription Table for ${props.tenantName}`}
          />
        </div>
      ) : (
        showNoData()
      )}
    </>
  );
}
